import { matchPath } from "react-router-dom";

import { PartialLocation } from "common/types/routing";

import { ROUTES } from "../../routing/routes";

import {
  makePasswordResetLink,
  makeSignInLink,
  makeSignUpLink
} from "./common-routes/links";

export const linkToSignIn = () => makeSignInLink("");

export const linkToSignUp = () => makeSignUpLink("");
export const linkToSignUpInvite = () => "/sign-up-invite";

export const linkToPasswordReset = () => makePasswordResetLink("");

export function getIsInParentSignUpPage(pathname: string) {
  return matchPath(pathname, {
    path: ROUTES.SIGN_UP_PARENT.path,
    exact: false
  });
}

export function combineLinkAndLocation(
  link: string | PartialLocation | null | undefined,
  location: PartialLocation
) {
  if (typeof link === "string") return { ...location, pathname: link };

  if (link) {
    return {
      ...location,
      ...link
    };
  }
  return location;
}
